import { enums, type Infer, object, string } from "superstruct";

import { JoinSessionStatus } from "@mpa/platform/enums/JoinSessionStatus";

import getEnumValues from "../enums/getEnumValues.js";
import { deserializeIsoDate, isoDate, serializeIsoDate } from "../scalar_types/isoDate.js";

export const JoinSessionSchema = object({
    id: string(),
    code: string(),
    createdAt: isoDate,
    expiresAt: isoDate,
    status: enums(getEnumValues(JoinSessionStatus)),
});

export type JoinSessionSerialized = Infer<typeof JoinSessionSchema>;

export default class JoinSession {
    id!: string;
    code!: string;
    createdAt!: Date;
    expiresAt!: Date;
    status!: JoinSessionStatus;

    serialize(): JoinSessionSerialized {
        return {
            id: this.id,
            code: this.code,
            createdAt: serializeIsoDate(this.createdAt),
            expiresAt: serializeIsoDate(this.expiresAt),
            status: this.status,
        };
    }

    static deserialize(data: JoinSessionSerialized): JoinSession {
        const joinSession = new JoinSession();
        joinSession.id = data.id;
        joinSession.code = data.code;
        joinSession.createdAt = deserializeIsoDate(data.createdAt);
        joinSession.expiresAt = deserializeIsoDate(data.expiresAt);
        joinSession.status = data.status;
        return joinSession;
    }
}
